const ySpacing = 100;
const xSpacing = 200;
export const graphComputed = (nodes, links, startNode, endNode, isTest) => {
  if (startNode === null || endNode === null) {
    return;
  }
  const nodeMap = new Map();
  const nodesAll = nodes.concat([startNode, endNode]);
  nodesAll.forEach((e) => nodeMap.set(e.nodeId, e));
  resetNodes(nodesAll);
  hierarchyNodes(startNode, links, nodeMap, 0);
  const group = new Map();
  const deepGroup = new Map();
  groupNodes(nodesAll, group);
  deepGroupNodes(nodesAll, links, deepGroup);
  fillNodePoint(group, deepGroup);
  checkNodes(group, deepGroup, nodesAll, links);
  const data = nodesAll.map((n) => {
    let color = 'rgb(193, 54, 49)';
    if (n.executed) {
      color = '#67C23A';
    }
    const { x, y } = n;
    return {
      value: [n],
      name: `(${n.nodeId})${n.nodeName}`,
      x,
      y,
      itemStyle: {
        color,
      },
    };
  });
  const edges = links.map((x) => {
    return {
      source: `(${x.previousNodeId})${nodeMap.get(x.previousNodeId).nodeName}`,
      target: `(${x.nextNodeId})${nodeMap.get(x.nextNodeId).nodeName}`,
      origin: x,
      value: x.id,
      label: {
        normal: {
          show: false,
          formatter: '{c}',
        },
      },
    };
  });
  let layer = 0;
  group.forEach((v) => {
    layer = v.length > layer ? v.length : layer;
  });
  return {
    x: group.size * xSpacing,
    y: layer * ySpacing,
    title: {
      text: '',
    },
    tooltip: {
      formatter: function (params) {
        if (params.dataType === 'edge') {
          if (!isTest) {
            const link = params.data.origin;
            const expression = link.regularExpression
              ? link.regularExpression
              : '';
            const inputItems = link.additionalInputItems
              ? link.additionalInputItems
              : '';
            return `条件: ${expression}<br/> 输入项: ${inputItems}`;
          }
          return '';
        }
        const node = params.data.value[0];
        if (
          isTest &&
          node.nodeId !== startNode.nodeId &&
          node.nodeId !== endNode.nodeId
        ) {
          const [input, output] = node.output
            ? node.output.split('%%')
            : ['', ''];
          return `输入: ${input}<br/> 输出: ${output}`;
        }
        return params.data.name;
      },
    },
    animation: true,
    animationDuration: 500,
    animationDurationUpdate: 1000,
    animationEasingUpdate: 'cubicOut',
    series: [
      {
        type: 'graph',
        layout: 'none',
        symbolSize: 50,
        hoverAnimation: true,
        focusNodeAdjacency: true,
        label: {
          normal: {
            show: true,
            color: 'rgba(0, 0, 0, 0.65)', //耿越加，修改lable字体颜色
          },
        },
        edgeSymbol: ['circle', 'arrow'],
        edgeSymbolSize: [4, 10],
        edgeLabel: {
          normal: {
            textStyle: {
              fontSize: 20,
            },
          },
        },
        data,
        edges,
        lineStyle: {
          opacity: 0.9,
          width: 1,
        },
      },
    ],
  };
};

function resetNodes(nodes) {
  nodes.forEach((e) => {
    e.hierarchy = null;
    e.x = null;
    e.y = null;
  });
}

function hierarchyNodes(parentNode, nodePointers, nodeMap, hierarchy) {
  const nodeHierarchy = parentNode.hierarchy;
  parentNode.hierarchy =
    nodeHierarchy && nodeHierarchy > hierarchy ? nodeHierarchy : hierarchy;
  const nextHierarchyNodes = nodePointers
    .filter((e) => e.previousNodeId === parentNode.nodeId)
    .map((e) => e.nextNodeId);
  nextHierarchyNodes.forEach((e) => {
    const node = nodeMap.get(e);
    hierarchyNodes(node, nodePointers, nodeMap, hierarchy + 1);
  });
}

function groupNodes(nodes, group) {
  nodes.forEach((e) => {
    const sameHierarchyNodes = group.get(e.hierarchy);
    if (sameHierarchyNodes) {
      group.set(e.hierarchy, sameHierarchyNodes.concat([e]));
    } else {
      group.set(e.hierarchy, Array.of(e));
    }
  });
}

function deepGroupNodes(nodes, links, group) {
  nodes.forEach((e) => {
    // get all the previous nodes
    const previousNodeIds = links
      .filter((s) => s.nextNodeId === e.nodeId)
      .map((s) => s.previousNodeId);
    if (previousNodeIds.length > 0) {
      // get the previous hierarchy nodes
      const parentNodeIds = nodes
        .filter((s) => previousNodeIds.indexOf(s.nodeId) !== -1)
        .filter((s) => s.hierarchy === e.hierarchy - 1)
        .map((s) => s.nodeId);
      // current hierarchy map, store previous node relate current hierarchy children
      let hierarchyMap = group.get(e.hierarchy);
      if (hierarchyMap) {
        parentNodeIds.forEach((s) => {
          let sameParentNodes = hierarchyMap.get(s);
          if (sameParentNodes && sameParentNodes.indexOf(e) === -1) {
            sameParentNodes.push(e);
          } else {
            sameParentNodes = Array.of(e);
          }
          hierarchyMap.set(s, sameParentNodes);
        });
      } else {
        hierarchyMap = new Map();
        parentNodeIds.forEach((s) => hierarchyMap.set(s, Array.of(e)));
        group.set(e.hierarchy, hierarchyMap);
      }
    } else {
      const hierarchyMap = new Map();
      hierarchyMap.set(-1, Array.of(e));
      group.set(0, hierarchyMap);
    }
  });
}

function fillNodePoint(group, deepGroup) {
  let layer = 0;
  group.forEach((v) => {
    layer = v.length > layer ? v.length : layer;
  });
  const yMax = layer * ySpacing;
  group.forEach((v, hierarchy) => {
    if (v.find((s) => s.fake)) {
      console.log('current hierarchy has fake node! hierarchy: ', hierarchy);
      v.forEach((e) => {
        e.x = null;
        e.y = null;
      });
    }
    const x = xSpacing * (hierarchy + 1);
    const previousHierarchy = group.get(hierarchy - 1);
    if (previousHierarchy && v.length > 1) {
      let yIndex = 1;
      previousHierarchy.forEach((e) => {
        const nodes = deepGroup.get(hierarchy).get(e.nodeId);
        nodes &&
          nodes.forEach((s) => {
            if (!s.y) {
              s.x = x;
              s.y = yMax / 2 - (yIndex / (v.length + 1)) * yMax;
              yIndex++;
            }
          });
      });
    } else {
      v.forEach((e) => {
        e.x = x;
        e.y = 0;
      });
    }
  });
}

function checkNodes(group, deepGroup, nodes, links) {
  const sameYPointMap = new Map();
  nodes.forEach((e) => {
    let sameYPointNodes = sameYPointMap.get(e.y);
    if (sameYPointNodes) {
      sameYPointNodes.push(e);
    } else {
      sameYPointNodes = Array.of(e);
    }
    sameYPointMap.set(e.y, sameYPointNodes);
  });
  let isCovered = false;
  Array.from(sameYPointMap.values()).some((v) => {
    if (v.length >= 3) {
      v.sort((a, b) => a.hierarchy - b.hierarchy);
      const nodePointers = [];
      // assemble and collect all current hierarchy pointer
      for (let i = 0; i < v.length; i++) {
        for (let j = i + 1; j < v.length; j++) {
          if (
            links.find(
              (s) =>
                s.previousNodeId === v[i].nodeId &&
                s.nextNodeId === v[j].nodeId,
            )
          ) {
            nodePointers.push({ previousNode: v[i], nextNode: v[j] });
          }
        }
      }
      // let pointers sort by hierarchy, ensure the last pointer have most layers
      nodePointers.sort(
        (a, b) =>
          a.nextNode.hierarchy -
          a.previousNode.hierarchy -
          (b.nextNode.hierarchy - b.previousNode.hierarchy),
      );
      for (let i = nodePointers.length - 1; i >= 0; i--) {
        const externalPointer = nodePointers[i];
        if (
          externalPointer.nextNode.hierarchy -
            externalPointer.previousNode.hierarchy <
          2
        ) {
          break;
        }
        for (let j = 0; j < i; j++) {
          const internalPointer = nodePointers[j];
          // internalPointer is contains by externalPointer
          if (
            externalPointer.previousNode.x < internalPointer.nextNode.x &&
            externalPointer.nextNode.x >= internalPointer.nextNode.x
          ) {
            console.log('externalPointer: ', externalPointer);
            console.log('internalPointer', internalPointer);
            console.log(
              'link covered! current hierarchy: ',
              internalPointer.nextNode.hierarchy,
            );
            isCovered = true;
            // ensure startNode and endNode shouldn't move
            if (!internalPointer.previousNode.nodeBlockType) {
              group
                .get(internalPointer.nextNode.hierarchy)
                .push({ fake: true });
            } else {
              group
                .get(internalPointer.previousNode.hierarchy)
                .push({ fake: true });
            }
            break;
          }
        }
        if (isCovered) {
          fillNodePoint(group, deepGroup);
          checkNodes(group, deepGroup, nodes, links);
          break;
        }
      }
    }
    return isCovered;
  });
}
